import { setProps } from '../props';

export default (props: any) => () => {

  setProps(props);
    
}